import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Text, LayoutItem } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';

export interface MpgContentProps {
  value: string;
  specId: string;
}

const MpgContent: React.FC<MpgContentProps> = ({ value, specId }) => {
  const { t } = useTranslation();

  return (
    <Layout direction="column" rowGap={SYS_SPACE_FIXED_50}>
      <LayoutItem>
        <Layout align="center" columnGap={SYS_SPACE_FIXED_50}>
          <Text
            variant={{
              order: '1',
              style: 'bold',
            }}
            data-testid={`${value}-${specId}-value`}
          >
            {value}
          </Text>
          <Text
            variant={{
              order: '1',
              style: 'normal',
            }}
          >
            {t(`featuresAndSpecsSection.categories.nonAudiOverview.specs.MPG.unit`)}
          </Text>
        </Layout>
      </LayoutItem>
      <LayoutItem>
        <Text
          variant={{
            order: '1',
            style: 'bold',
          }}
          data-testid={`${value}-${specId}-copy`}
        >
          {t(`featuresAndSpecsSection.categories.nonAudiOverview.specs.MPG.${specId}`)}
        </Text>
      </LayoutItem>
    </Layout>
  );
};

export default MpgContent;
